import { render, staticRenderFns } from "./ProductosDetalle.vue?vue&type=template&id=0f40039c"
import script from "./ProductosDetalle.vue?vue&type=script&lang=js"
export * from "./ProductosDetalle.vue?vue&type=script&lang=js"
import style0 from "./ProductosDetalle.vue?vue&type=style&index=0&id=0f40039c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports